import styled from 'styled-components';
import { Box, Text, Button } from '@rsos/components/capstone/base';
import Card from '@rsos/components/capstone/base/Card';

export const DataSourceCardContainer = styled(Card)`
  margin: 10px 0;
  border-radius: 5px;
  border: ${p => `1px solid ${p.theme.colors.heavyLineOutline}`};
  background: ${p => p.theme.colors.background};
`;

export const StyledCheckbox = styled.input.attrs({
  type: 'checkbox',
})`
  width: 13px;
  height: 13px;
`;

export const CardBodyContainer = styled(Box)`
  flex: 1 0 auto;
`;

export const CardFooterContiner = styled(Box).attrs({
  horizontal: true,
  justify: 'space-between',
  align: 'center',
})`
  flex-shrink: 0;
`;

export const DataSourceDescription = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
})`
  max-height: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RolesDisplayDeleteContainer = styled(Box).attrs({
  horizontal: true,
  justify: 'space-between',
  grow: true,
  pl: '5px',
  height: 25,
})`
  &:hover {
    background: ${p => p.theme.colors.lightLineDivider};
    cursor: pointer;
    border-radius: 4px;
  }
`;

export const StyledButton = styled(Button)`
  display: none;
  ${RolesDisplayDeleteContainer}:hover & {
    display: flex;
  }
`;
